export const INIT = 'app/LocationsListPage/INIT';
export const INIT_SUCCESS = 'app/LocationsListPage/INIT_SUCCESS';
export const INIT_FAILED = 'app/LocationsListPage/INIT_FAILED';
